import { T } from "services/lang/LanguageService";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import React from "react";
import { SparkLineProps } from "./SparkLineTypes";

interface SparkLineEditorGeneralProps {
  currentConfig: SparkLineProps;
  setCurrentConfig: (currentConfig: SparkLineProps) => void;
}

const SparkLineEditorGeneral = ({
  currentConfig,
  setCurrentConfig,
}: SparkLineEditorGeneralProps) => {
  const chartToExpandOptions = () => {
    const firstChart = {
      label: currentConfig.chartTitle ?? "Chart 1",
      value: 0,
    };

    const otherCharts = currentConfig.multipleCharts.map((chart, i) => ({
      label: chart.chartTitle ?? `Chart ${i + 2}`,
      value: i + 1,
    }));

    return [firstChart, ...otherCharts];
  };

  return (
    <div className="flex flex-row gap-3">
      {!currentConfig.generalProperties?.chartsInOneBox && (
        <>
          <div className="flex flex-column gap-2 w-2">
            <label htmlFor="hideValues">{T("action.hide-values")}</label>
            <InputSwitch
              id="hideValues"
              checked={currentConfig.generalProperties?.hideValues ?? false}
              onChange={e =>
                setCurrentConfig({
                  ...currentConfig,
                  generalProperties: { ...currentConfig.generalProperties, hideValues: e.value },
                })
              }
            />
          </div>
          <div className="flex flex-column gap-2 w-2">
            <label htmlFor="expandAll">{T("action.expand-all")}</label>
            <InputSwitch
              id="expandAll"
              checked={currentConfig.generalProperties?.expandAll ?? false}
              onChange={e =>
                setCurrentConfig({
                  ...currentConfig,
                  generalProperties: { ...currentConfig.generalProperties, expandAll: e.value },
                })
              }
            />
          </div>
        </>
      )}
      <div className="flex flex-column gap-2 w-4">
        <label htmlFor="chartsInOneBox">{T("action.display-charts-in-one-box")}</label>
        <InputSwitch
          id="chartsInOneBox"
          checked={currentConfig.generalProperties?.chartsInOneBox ?? false}
          onChange={e =>
            setCurrentConfig({
              ...currentConfig,
              generalProperties: { ...currentConfig.generalProperties, chartsInOneBox: e.value },
            })
          }
        />
      </div>
      {!currentConfig.generalProperties?.expandAll && (
        <div className="flex flex-column gap-2 w-4">
          <label htmlFor="expandedChart">{T("label.chart-to-expand-by-default")}</label>
          <Dropdown
            id="expandedChart"
            value={currentConfig.generalProperties?.expandedChartIndex ?? 0}
            options={chartToExpandOptions()}
            onChange={e =>
              setCurrentConfig({
                ...currentConfig,
                generalProperties: {
                  ...currentConfig.generalProperties,
                  expandedChartIndex: e.value,
                },
              })
            }
          />
        </div>
      )}
      {!currentConfig.generalProperties?.expandAll && currentConfig.generalProperties?.chartsInOneBox && (
        <div className="flex flex-column gap-2 w-4">
          <label htmlFor="displayTitlesInRow">{T("action.display-titles-in-row")}</label>
          <InputSwitch
           id="displayTitlesInRow"
            checked={currentConfig.generalProperties?.displayTitlesInRow ?? false}
            onChange={e =>
              setCurrentConfig({
                ...currentConfig,
                generalProperties: {
                  ...currentConfig.generalProperties,
                  displayTitlesInRow: e.value,
                },
              })
            }
          />
        </div>
      )

      }
    </div>
  );
};

export default SparkLineEditorGeneral;
